import { getAppStore, getEntity, Publisher, UserContext } from '../../../../../@data';
import { PublisherServingConfig } from '../../../../../@data/store/schema/models/ServingConfigs';

export async function fetchPublisherServingConfig(publisher: Publisher, userContext?: UserContext): Promise<PublisherServingConfig> {
  const effectiveUserContext = userContext || getAppStore().userContext;
  const publisherServingConfig = await getEntity([publisher], effectiveUserContext, PublisherServingConfig);
  return publisherServingConfig;
}
